import React, { useEffect, useState } from "react";
import { Target, Star, BadgeCheck, Trophy } from "lucide-react";
import { api } from "../../lib/api";
import { C, FONT, namaKota } from "./ui";
import { Sheet, Empty } from "./Sheet";
import { TOKEN_KEY, Verifikasi } from "./PesanSheet";
import { Inisial } from "./SuratUI";
import { EventBanner, RantaiCard, MisiRow, BonusCard, PoinRow } from "./MisiUI";

// Klasemen Poin Rajin hari ini (top 20) — barisku disorot
function Klasemen({ token, onBack, onClose }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.misiKlasemen(token).then(setD).catch(() => setD({ daftar: [] })); }, [token]);
  return (
    <Sheet testid="misi-klasemen" title="Klasemen Poin Rajin" sub={d ? `Hari ini · ${d.peserta} warga · poinku ${d.poin}${d.peringkat ? ` · peringkat #${d.peringkat}` : ""}` : "Memuat…"} onBack={onBack} onClose={onClose}>
      {d && d.daftar.length === 0 && <Empty icon={Trophy} testid="klasemen-kosong" text="Belum ada yang mengumpulkan poin hari ini. Jadilah yang pertama!" />}
      {(d?.daftar || []).map(r => (
        <div key={r.ig_username} data-testid={`klasemen-${r.peringkat}`} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 10px", borderRadius: 16, background: r.saya ? C.blueSoft : "transparent", borderTop: r.saya ? 0 : `1px solid ${C.line}` }}>
          <b style={{ width: 26, textAlign: "center", fontSize: 13, color: r.peringkat <= 3 ? "#f4b400" : C.sub }}>#{r.peringkat}</b>
          <Inisial w={r} size={34} />
          <span style={{ flex: 1, minWidth: 0 }}><b style={{ display: "block", fontSize: 13.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>@{r.ig_username}{r.saya ? " (kamu)" : ""}</b><span style={{ fontSize: 11.5, color: C.sub }}>{r.nama} · {namaKota(r.city_id)} · {r.selesai_n} misi</span></span>
          <b style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 14 }}><Star size={13} color="#f4b400" fill="#f4b400" /> {r.poin}</b>
        </div>
      ))}
    </Sheet>
  );
}

// Sheet Misi Harian (kartu kaca Jawsel, ala referensi): header + chip poin, spanduk event spesial, rantai hari,
// daftar 10 misi (Ke sana → tempat misi), bonus 3 misi otomatis, Poin Rajin → Klasemen. Hanya pemegang Kartu Warga.
export function MisiSheet({ cityId, onClose, onKeSana }) {
  const [token] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [verif, setVerif] = useState(false), [d, setD] = useState(null), [klasemen, setKlasemen] = useState(false);
  useEffect(() => { if (token) api.misiHarian(token).then(setD).catch(() => setD(null)); }, [token]);
  if (verif) return <Verifikasi cityId={cityId} onBack={() => setVerif(false)} onClose={onClose} />;
  if (klasemen) return <Klasemen token={token} onBack={() => setKlasemen(false)} onClose={onClose} />;
  const poinChip = d && <span data-testid="misi-poin-chip" style={{ display: "inline-flex", alignItems: "center", gap: 4, height: 30, padding: "0 10px", borderRadius: 99, background: "#fff9e6", border: "1px solid #f4b400", fontSize: 12.5, fontWeight: 800, flex: "none" }}><Star size={12} color="#f4b400" fill="#f4b400" /> {d.poin}</span>;
  return (
    <Sheet testid="misi-sheet" title="Misi Harian" sub={d ? d.label : "10 misi, berganti tiap 00.00 WIB"} icon={Target} onClose={onClose} aksi={poinChip}>
      {!token && (
        <div style={{ textAlign: "center" }}>
          <Empty icon={Target} testid="misi-tanpa-kartu" text="Misi harian hanya untuk pemegang Kartu Warga: 10 misi tiap hari, hadiah koin, rantai hari, dan bonus gaji." />
          <button data-testid="misi-jadi-warga" onClick={() => setVerif(true)} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, width: "100%", padding: "13px 18px", border: 0, borderRadius: 99, background: C.blue, color: "#fff", fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: FONT }}><BadgeCheck size={17} /> Jadi Warga Jawsel</button>
        </div>
      )}
      {token && !d && <p style={{ fontSize: 12.5, color: C.sub, margin: "8px 0" }}>Memuat misi…</p>}
      {d && (
        <>
          {d.event && <EventBanner e={d.event} onIkut={() => onKeSana(d.event.tujuan)} />}
          <RantaiCard r={d.rantai} />
          <p style={{ margin: "14px 2px 2px", fontSize: 11, fontWeight: 800, letterSpacing: 1.2, textTransform: "uppercase", color: C.sub, display: "flex", justifyContent: "space-between" }}><span>Misi hari ini</span><span data-testid="misi-selesai-n">{d.selesai_n}/{d.total} selesai</span></p>
          <div data-testid="misi-daftar">{d.misi.map(m => <MisiRow key={m.key} m={m} onKeSana={x => onKeSana(x.tujuan)} />)}</div>
          <BonusCard b={d.bonus} selesaiN={d.selesai_n} />
          <PoinRow poin={d.poin} peringkat={d.peringkat} onKlasemen={() => setKlasemen(true)} />
        </>
      )}
    </Sheet>
  );
}
